import React, { useEffect, useRef, useState } from "react";
import cx from "classnames";
import { PauseIcon, PlayIcon } from "assets";
import { MediaPlayButton } from "media-chrome/react";
import { useMediaSelector } from "media-chrome/dist/react/media-store";
import "./FadePlayButton.scss";

const SIZE = 40;

const FadePlayButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [animationKey, setAnimationKey] = useState(0);
  const isInitialRenderRef = useRef(true);
  const prevMediaPausedRef = useRef<boolean | undefined>(undefined);
  const prevMediaIsFullscreenRef = useRef<boolean | undefined>(undefined);
  const mediaPaused = useMediaSelector((state) => state.mediaPaused);
  const mediaIsFullscreen = useMediaSelector(
    (state) => state.mediaIsFullscreen
  );

  useEffect(() => {
    if (isInitialRenderRef.current) {
      isInitialRenderRef.current = false;
      prevMediaPausedRef.current = mediaPaused;
      prevMediaIsFullscreenRef.current = mediaIsFullscreen;

      return;
    }

    const isFullscreenToggled =
      prevMediaIsFullscreenRef.current !== mediaIsFullscreen;
    prevMediaIsFullscreenRef.current = mediaIsFullscreen;

    const isPausedChanged = prevMediaPausedRef.current !== mediaPaused;
    prevMediaPausedRef.current = mediaPaused;

    if (isFullscreenToggled || !isPausedChanged) {
      return;
    }

    setIsVisible(false);

    const rafId = requestAnimationFrame(() => {
      setAnimationKey((prev) => prev + 1);
      setIsVisible(true);
    });

    const timeoutId = setTimeout(() => {
      setIsVisible(false);
    }, 800);

    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutId);
    };
  }, [mediaPaused, mediaIsFullscreen]);

  return (
    <div
      key={animationKey}
      className={cx(
        "fade-play-button play-button primary absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform bg-transparent",
        {
          "fade-play-button--visible": isVisible,
        }
      )}
    >
      <MediaPlayButton className="play-button primary bg-transparent" noTooltip>
        <span slot="pause">
          <PlayIcon width={SIZE} height={SIZE} />
        </span>
        <span slot="play">
          <PauseIcon width={SIZE} height={SIZE} />
        </span>
      </MediaPlayButton>
    </div>
  );
};

export default FadePlayButton;
